var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import ButtonV2 from "../../Atoms/ButtonV2";
var ClearApplyButons = function (_a) {
    var _b = _a.clearCtaText, clearCtaText = _b === void 0 ? "Clear" : _b, _c = _a.submitCtaText, submitCtaText = _c === void 0 ? "Apply" : _c, onClear = _a.onClear, handleSubmit = _a.handleSubmit, _d = _a.isValid, isValid = _d === void 0 ? true : _d, _e = _a.isDirty, isDirty = _e === void 0 ? true : _e;
    return (_jsxs(Stack, __assign({ direction: "row", justifyContent: "flex-end", mt: 4 }, { children: [_jsx(ButtonV2, __assign({ variant: "secondary", onClick: onClear, size: "small", type: "button", "data-testid": "btn-clear-range", sx: { mr: 4 } }, { children: clearCtaText })), _jsx(ButtonV2, __assign({ size: "small", type: handleSubmit ? "button" : "submit", disabled: !isValid || !isDirty, onClick: handleSubmit, "data-testid": "btn-apply-range" }, { children: submitCtaText }))] })));
};
export default ClearApplyButons;
